import { Environment } from '@definitions/environment'

const authorization = `Basic ${btoa(`partner-client:3lP@n4d3roC0n3l.P4n`)}`

export const environment: Environment = Object.freeze({
	production: true,
	endpoint: 'https://api-web.corepark.com',
	authorization,
	region: 'us-east-1',
	firebaseConfig: {
		apiKey: 'AIzaSyDQpplpxP7_WgPyG-CA12z_awusn2NBOIc',
		authDomain: 'corepark-services.firebaseapp.com',
		databaseURL: 'https://corepark-services.firebaseio.com',
		projectId: 'corepark-services',
		storageBucket: 'corepark-services.appspot.com',
		messagingSenderId: '582077607268',
		appId: '1:582077607268:web:f4aea7aecf229e6fb81e71',
		measurementId: 'G-XPSSJMYMY4',
	},
	secretKey: '.F1r3B4$3-2o21%(',
})
